import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSlackInstallationsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetSlackInstallationsQuery = {
  __typename?: 'Query';
  slackInstallations: {
    __typename?: 'SlackInstallationConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'SlackInstallationEdge';
      node: {
        __typename?: 'SlackInstallation';
        id: any;
        name?: string | null;
        botUserId: string;
        botUserName?: string | null;
        slackTeamId: string;
        teamDomain?: string | null;
        tokenScopes?: Array<string> | null;
        isActive: boolean;
        createdAt: any;
        updatedAt: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export const GetSlackInstallationsDocument = gql`
  query GetSlackInstallations {
    slackInstallations {
      edges {
        node {
          id
          name
          botUserId
          botUserName
          slackTeamId
          teamDomain
          tokenScopes
          isActive
          createdAt
          updatedAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

/**
 * __useGetSlackInstallationsQuery__
 *
 * To run a query within a React component, call `useGetSlackInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackInstallationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSlackInstallationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSlackInstallationsQuery,
    GetSlackInstallationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSlackInstallationsQuery,
    GetSlackInstallationsQueryVariables
  >(GetSlackInstallationsDocument, options);
}
export function useGetSlackInstallationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSlackInstallationsQuery,
    GetSlackInstallationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSlackInstallationsQuery,
    GetSlackInstallationsQueryVariables
  >(GetSlackInstallationsDocument, options);
}
export function useGetSlackInstallationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSlackInstallationsQuery,
        GetSlackInstallationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSlackInstallationsQuery,
    GetSlackInstallationsQueryVariables
  >(GetSlackInstallationsDocument, options);
}
export type GetSlackInstallationsQueryHookResult = ReturnType<
  typeof useGetSlackInstallationsQuery
>;
export type GetSlackInstallationsLazyQueryHookResult = ReturnType<
  typeof useGetSlackInstallationsLazyQuery
>;
export type GetSlackInstallationsSuspenseQueryHookResult = ReturnType<
  typeof useGetSlackInstallationsSuspenseQuery
>;
export type GetSlackInstallationsQueryResult = Apollo.QueryResult<
  GetSlackInstallationsQuery,
  GetSlackInstallationsQueryVariables
>;
